import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadCrumbComponent } from '../../components/bread-crumb/bread-crumb.component';
import { HeaderTitleComponent } from '../../components/header-title/header-title.component';
import { MainHeaderComponent } from '../../components/main-header/main-header.component';
import { DataTableModule } from 'angular-6-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataFilterPipe } from '../../pipes/data-filter.pipe';
import { NumberOnlyDirective } from '../../services/common/number-only-directive'
import { PercentageDirective } from '../../services/common/percent.directive'
import { PercentageMaskDirective } from '../../services/common/percentage-mask.directive';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { InputRestrictionDirective } from '../../services/common/input-restriction.directive';
import { NgxPrintModule } from 'ngx-print';
import { NgxPaginationModule } from 'ngx-pagination';
import { TwoDigitDecimaNumberDirective } from '../../services/common/two-digit-decima-number-mask.directive'
import { StaticSearchListComponent } from '../../components/static-search-list/static-search-list.component';
import { SearchListComponent } from '../../components/search-list/search-list.component';
import { IndividualUploadDocumentsComponent } from '../../components/individual-upload-documents/individual-upload-documents.component';
import { PaginationComponent } from '../../components/pagination/pagination.component';

@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        RouterModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        NgbModule.forRoot(),
        ChartsModule,
        ModalModule.forRoot(),
        NgxPrintModule,
        NgxPaginationModule
    ],
    declarations: [
        BreadCrumbComponent,
        HeaderTitleComponent,
        MainHeaderComponent,
        NumberOnlyDirective,
        PercentageDirective,
        PercentageMaskDirective,
        TwoDigitDecimaNumberDirective,
        InputRestrictionDirective,
        // DataFilterPipe,
        // StaticSearchListComponent,
        // SearchListComponent,
        // IndividualUploadDocumentsComponent,
        // PaginationComponent
    ],
    exports: [
        HttpModule,
        RouterModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BreadCrumbComponent,
        HeaderTitleComponent,
        MainHeaderComponent,
        NumberOnlyDirective,
        PercentageDirective,
        TwoDigitDecimaNumberDirective,
        PercentageMaskDirective,
        InputRestrictionDirective,
        // DataFilterPipe,
        // StaticSearchListComponent,
        // SearchListComponent,
        // IndividualUploadDocumentsComponent,
        // PaginationComponent
    ]
})
export class SuperSharedModule { }
